<template>
  <div class="case-list">
    <div class="page-title font-s24 c33">医疗方案</div>
    <div class="articl-list clearfix">
      <div class="fl list-l">
        <img src="../../../src/assets/image/care.png">
      </div>
      <div class="fr list-r">
        <div class="list clearfix  font-s14 pd-t-20" v-for="(item,index) in list" :key="index" @click="caseDetail(item.id,item.is_login,item.is_vip,item.type)">
          <div class="fl">
            <span class="c66">{{item.title}}</span>
            <a class="c06" v-if="item.type==2">(泛康诊所提供)</a>
            <a class="c06" v-if="item.type==1">(测评)</a>
            <a class="c06" v-if="item.type==3">(第三方提供)</a>
          </div>
           <div class="fr c66">
            <div class="i-block">
              <img src="../../../src/assets/image/dp.png" alt="" style="vertical-align: middle;width:16px;height:16px">
              <span style="vertical-align: middle;margin-left:5px">{{item.org_name}}</span>
              <span style="vertical-align: middle;margin-left:10px">{{item.addtime}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HealthySchemeList } from "../../api/api";
import { types } from "util";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.$axios.post(HealthySchemeList, {}).then(
      (res) => {
        if (res.data.code == 1) {
          this.list = res.data.data;
        } else {
          this.list = [];
        }
      },
      (err) => {
        this.list = [];
      }
    );
  },
  methods: {
    caseDetail(id, login, vip, type) {
      //答题
      var item = {
        id: id,
        type: type, //类型    1量表 2新闻   3商品
      };
      if (type != 3) {
        this.$router.push({
          name: "healthCareDetailResult",
          query: { item: JSON.stringify(item) },
        });
      } else {
        this.$router.push({
          name: "healthCareTreatmentPlan",
          query: { item: JSON.stringify(item) },
        });
      }
    },
  },
};
</script>

<style lang="scss">
</style>
